import { TimesheetsTableHeaderCell } from '../Cells/TimesheetsTableHeaderCell';
import { TableRowHeader } from './styles/TimesheetsHeaderRow.styled';

interface TimeSheetsHeaderRowProps {
  headerData: {
    title: string;
    new_date: string;
  }[];
}

export const TimeSheetsHeaderRow = ({
  headerData,
}: TimeSheetsHeaderRowProps) => {
  return (
    <TableRowHeader>
      <TimesheetsTableHeaderCell
        title={headerData[0].title}
        index={0}
        key={0}
      />
      {headerData.map((cell, index) => {
        if (index !== 0) {
          return (
            <TimesheetsTableHeaderCell
              title={cell.title}
              index={index}
              key={cell.title}
              date={cell.new_date}
            />
          );
        }
      })}
    </TableRowHeader>
  );
};
